import type { TPageTranslations } from '@crehana/i18n';

import { COURSE_DETAIL_PAGE_KEY } from '@/views/OrgCourseDetail/constants';

import type { TKeys } from './types';

const pt: TPageTranslations<TKeys, typeof COURSE_DETAIL_PAGE_KEY> = {
  [COURSE_DETAIL_PAGE_KEY]: {
    UPDATED_AT: 'Atualizado em',
    ABOUT_TITLE: 'Sobre o que é este curso?',
    LESSONS_SECTION_TITLE: 'Agenda do curso',
    WATCH_TRAILER: 'Assista ao trailer',
    NEW: 'Novo',
    STUDENTS: 'Estudiantes',
    SEO_TITLE: 'Curso online de',
    SEO_TITLE_2: 'Curso online',
    SHOW_MORE: 'Ver mais',
    SHOW_LESS: 'Veja menos',
    INFO_SECTION_TITLE: 'Informação do curso',
    TOTAL_DURATION: 'Duração:',
    TOTAL_ATTACHMENTS_TEXT: ' Arquivos adjuntos',
    ATTACHMENT_TEXT: ' Arquivo adjunto',
    ACCESS_TEXT: 'Acesse pelo aplicativo',
    TRY_COURSE: '¡Prove grátis!',
    TEMPORAL_ACCESS: 'Acceso gratuito por 24hrs!',
    FREE_SUBSCRIPTION: 'Registre-se gratuitamente!',
    SUBSCRIBE_NOW: 'INSCREVA-SE AGORA!',
    GO_TO_COURSE: 'Vá para o curso',
    REQUIRED: 'Obrigatório',

    LEVEL_LABEL: 'Nível',
    LEVEL_TITLE: 'DIFICULDADE',
    MODULES: '{{count}} Módulo',
    MODULES_plural: '{{count}} Módulos',
    LESSONS_TOTAL: '{{count}} Lição',
    LESSONS_TOTAL_plural: '{{count}} Lições',
    TIME_DURATION: '{{totalDuration}} duração total',

    ERROR_VIEW_MESSAGE: 'Ocorreu um erro, por favor tente novamente',
    ERROR_VIEW_BUTTON: 'Recarregar página',
    ERROR_VIEW_COURSE_NOT_FOUND: 'Curso não disponível',
    ERROR_VIEW_COURSE_NOT_FOUND_DESCRIPTION:
      'Este curso pode não existir, pertencer a outra organização ou você não tem as permissões necessárias para acessá-lo. Por favor, entre em contato com seu administrador se acreditar que isso é um erro.',
    ERROR_VIEW_COURSE_NOT_FOUND_BUTTON: 'Voltar à página anterior',
    KNOWLEDGEHUB_HOME: 'Catálogo',
    KNOWLEDGEHUB_DETAIL: 'Detalhes do curso',

    ENROLLMENTS_CURRENT_COURSE_DIALOG_TITLE: 'Colaboradores inscritos no curso',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION:
      'Consulte a lista de colaboradores inscritos no curso. Você pode ver quem foi adicionado.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_DESCRIPTION_BOLD:
      'Novas atribuições podem levar alguns minutos para serem processadas antes de serem exibidas.',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_TITLE: 'Usuários',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_SEARCH: 'Buscar',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_NAME: 'Nome',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_HEAD_ROLE: 'Atribuído',
    ENROLLMENTS_CURRENT_COURSE_DIALOG_TABLE_ROLE_ADMINISTRATOR: 'Administrador',
    ENROLLMENTS_CURRENT_COURSE_EMPTY:
      'Nenhum colaborador sob sua responsabilidade tem este curso atribuído.',
    ENROLLMENTS_CURRENT_COURSE_INFO:
      'Consulte a lista de seus colaboradores inscritos no curso. Você pode ver quem atribuiu o conteúdo.',
    ENROLLMENTS_CURRENT_COURSE_INFO_AVATAR_LABEL: 'Colaboradores',
    ENROLLMENTS_CURRENT_COURSE_INFO_BUTTON: 'Ver mais',
    ENROLLMENTS_CURRENT_COURSE_INFO_NOTE:
      'As atribuições podem levar pelo menos uma hora ou mais para serem refletidas na lista.',
    LEADER_ASSIGN_TEAM_BUTTON: 'Atribuir à minha equipe',

    ENROLLMENTS_CURRENT_COURSE_ERROR_TITLE: 'Erro ao carregar dados',
    ENROLLMENTS_CURRENT_COURSE_ERROR_DESCRIPTION:
      'Não foi possível carregar as informações de inscrição. Tente novamente.',
    ENROLLMENTS_CURRENT_COURSE_ERROR_BUTTON: 'Tentar novamente',
  },
};

export default pt;
